export default __webpack_public_path__ + "static/media/flower-left.a297c0a8.png";